import { Grid, GridCustomCellProps, GridColumn as Column, GridDetailRowProps, GridPageChangeEvent } from '@progress/kendo-react-grid';
import { Loader } from "@progress/kendo-react-indicators";
import { useEffect, useState } from "react";
import { fetchApi } from "../../services/api";
import { openWindowPerc } from "../../services/openWindow";
import { SalesHistoryViewModel } from "../../TypeGen/Customer/SalesHistory/sales-history-view-model";

interface SalesHistoryDetailViewModel {
  OrderID: number;

  LineHaul: number;
  Accessorials: number;
  FuelSurcharge: number;
  TotalCharges: number;

  InvoiceNumber: string;
  InvoiceLetter: string;

  ShipperName: string;
  ShipperLocation: string;

  ConsigneeName: string;
  ConsigneeLocation: string;
}

interface SalesDetailProps extends GridDetailRowProps {
  customerId: string;
  useBillTo: boolean;
  dataItem: SalesHistoryViewModel;
}

const PAGE_SIZE = 8;

const SalesHistoryDetail = ({ dataItem, customerId, useBillTo }: SalesDetailProps) => {
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState<SalesHistoryDetailViewModel[]>([]);
  const [skip, setSkip] = useState(0);

  useEffect(() => {
    setLoading(true);
    fetchApi(`/api/Customer/CustomerSalesHistoryDetail`,
      {
        CustomerID: customerId,
        YYYYMM: dataItem.YYYYMM,
        UseBillToCustomer: useBillTo
      }, 'POST')
      .then((response) => setOrders(response.Orders))
      .catch(() => alert('Unable to load order details.'))
      .finally(() => setLoading(false));
  }, [customerId, dataItem.YYYYMM, useBillTo]);

  const InvoiceNumberCell = (props: GridCustomCellProps) => {
    if (!props.field)
      return null;

    const dataItem: SalesHistoryDetailViewModel = props.dataItem;

    return (
      <td {...props.tdProps}>
        <a href="#" style={{ color: "#338aff" }} tabIndex={-1} className="ml-2" title='Invoice View' onClick={(e) => {
          e.preventDefault();
          openWindowPerc(`/Invoice/View/${dataItem.OrderID}/${dataItem.InvoiceLetter}`, .9, .85);
        }}>{dataItem.InvoiceNumber}</a>
      </td>
    );
  };

  const handlePageChange = (event: GridPageChangeEvent) => {
    setSkip(event.page.skip);
  };

  const pagedData = orders.slice(skip, skip + PAGE_SIZE);
  if (loading) return <Loader type="pulsing" size="small" />;
  if (!orders.length) return <div className="k-text-center">No orders found for this period.</div>;

  return (
    <Grid
      data={pagedData}
      skip={skip}
      take={PAGE_SIZE}
      total={orders.length}
      pageable={true}
      onPageChange={handlePageChange}>      
      <Column field="InvoiceNumber" title="Invoice #" cells={{ data: InvoiceNumberCell }} />
      <Column
        title="Shipper"
        cells={{ data: (props) => {
          const { ShipperName, ShipperLocation } = props.dataItem;
          return (
            <td {...props.tdProps}>
              <div>{ShipperName}</div>
              <div>{ShipperLocation}</div>
            </td>
          );
        } }}
      />
      <Column
        title="Consignee"
        cells={{ data: (props) => {
          const { ConsigneeName, ConsigneeLocation } = props.dataItem;
          return (
            <td {...props.tdProps}>
              <div>{ConsigneeName}</div>
              <div>{ConsigneeLocation}</div>
            </td>
          );
        } }}
      />
      <Column field="LineHaul" title="Line Haul" format="{0:c2}" />
      <Column field="Accessorials" title="Accessorials" format="{0:c2}" />
      <Column field="FuelSurcharge" title="Fuel Surcharge" format="{0:c2}" />
      <Column field="TotalCharges" title="Total Charges" format="{0:c2}" />
    </Grid>
  );
};

export default SalesHistoryDetail;